module.exports = __webpack_public_path__ + "static/logo.fc99968d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.svg
// module id = 843
// module chunks = 114276838955818